<template>

  <main class="main">

    <div class="container">
      
      <h1 class="title title_h1">News</h1>

    </div>

    <div
      v-if="!loaded"
      class="loader"
    ></div>

    <div
      v-else
      class="container"
    >

      <div
        v-for="item in news"
        class="layoyt layout_default-page"
      >
        
        <div class="layout__item">
        
          <h2 class="title title_h2">{{ item.date }}</h2>

        </div>

        <div class="layout__item">
          
          <div class="news-item news-item_short">

            <div class="news-item__title">{{ item.title }}</div>

            <div class="news-item__wrapper">
              
              <div class="news-item__short-desc">{{ item.short_desc }}</div>

              <div class="news-item__read-more">
                
                <router-link
                  :to="`/news/${ item.id }`"
                  class="link link_gray"
                >Read more</router-link>

              </div>

            </div>

          </div>

        </div>

      </div>

      <a
        v-show="next !== null"
        @click.prevent="onClickViewMoreLink"
        href="#"
        class="link link_news-view-more"
      >
      
        <span class="link__text">View more</span>
      
      </a>

    </div>

  </main>

</template>

<script>
  export default {
    name: 'NewsPage',

    data() {
      return {
        loaded: false,
        news: [],
        next: null,
      };
    },

    created() {
      this.fetchData();
    },

    methods: {
      fetchData(url) {
        url = url || '/api/news';

        this.$http.get(url)

        .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.news.push(...data.news);
        this.next = data.next;

        this.loaded = true;
      },

      onClickViewMoreLink() {
        this.fetchData(this.next);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/pages/news/Index.vue